/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import i18n from '@core/plugins/i18n';

export class Feature extends DaoModel {
  constructor(guid, legendNameEs, legendNameEn, legendOrder) {
    super(guid);
    this.legendNameEs = legendNameEs || '';
    this.legendNameEn = legendNameEn || '';
    this.legendOrder = legendOrder || 0;
  }

  static toInstance(props = {}) {
    return new Feature(props.guid, props.legend_name_es, props.legend_name_en, props.legend_order);
  }

  get legendName() {
    const language = i18n.locale;
    return this[`legendName${language.charAt(0).toUpperCase() + language.slice(1)}`];
  }
}
